import React from "react";
import Styled from "./CarouselStyles";

export const Carousel = props => {
    const { id, length, index, onClick, style, isDialog = false } = props;

    return (
        <Styled.CarouselCompoundContainer style={style} id={id}>
            {new Array(length || 2).fill(true).map((_, arrIndex) => {
                return isDialog ? (
                    <Styled.DialogCarouselContainer
                        isActive={arrIndex === index}
                        key={`value${arrIndex}`}
                        onClick={onClick(arrIndex)} />
                ) : (

                    <Styled.CarouselContainer
                        isActive={arrIndex === index}
                        key={`value${arrIndex}`}
                        onClick={onClick(arrIndex)}
                    />
                )
            })}
        </Styled.CarouselCompoundContainer>
    )
}

export default React.memo(Carousel)